import React from "react";
import Typography from "@mui/material/Typography";
import MenuList from "@mui/material/MenuList";
import Menu from "@mui/material/Menu";
import { useTranslation } from "react-i18next";

import QuestionTypeItem from "../AddButton/QuestionTypeItem";
import { choiceQuestions } from "../itemTypesAddButton";
import { MenuItem } from "@mui/material";

export default function ChoiceMenu({
  open, // open the menu
  anchorRef, // position of the menu
  placement,
  selectedType,
  handleClose,
  handleItemClick,
}) {
  const { t } = useTranslation();
  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorRef.current}
      open={open}
      onClose={handleClose}
    >
      <Typography
        disabled
        variant="subtitle2"
        sx={{
          textAlign: "left",
          color: "rgba(0, 0, 0, 0.54)",
          paddingTop: 1,
          paddingLeft: 2
        }}
      >
        {t("editor.choiceQuestions")}
      </Typography>
      <MenuList>
        {choiceQuestions.map((item) => (
          <QuestionTypeItem
            key={item.type}
            type={item.type}
            handleItemClick={handleItemClick}
            isSelected={selectedType === item.type}
            icon={item.icon}
            title={t(`editor.questionTypes.${item.type}.title`)}
            manualUrl={item.manualUrl}
          />
        ))}
      </MenuList>
    </Menu>
  );
}
